import { allTranslations } from './translations/allTranslations';
export function createTranslationObject(locale) {
    let translations = {};
    Object.keys(allTranslations).forEach(translationPath => {
        const localeTranslations = Object.entries(allTranslations[translationPath]).reduce((result, [key, translation]) => {
            result[key] = translation[locale];
            return result;
        }, {});
        translations = Object.assign(translations, localeTranslations);
    });
    return translations;
}
export function getTranslation(key, locale) {
    var _a;
    const translationObject = createTranslationObject(locale);
    return (_a = translationObject[key]) !== null && _a !== void 0 ? _a : key;
}
export function getTranslationGetter(locale) {
    const translationObject = createTranslationObject(locale);
    return key => { var _a; return (_a = translationObject[key]) !== null && _a !== void 0 ? _a : key; };
}
